import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './blog.css'

const Blog = (props) => {
  return (
    <div className="blog-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta property="og:title" content="Blog - Well Off Notable Fish" />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/blog"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="blog-hero-section">
        <video
          src="https://videos.pexels.com/video-files/6963744/6963744-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playsInline="true"
          className="hero-video"
        ></video>
        <div className="hero-overlay"></div>
        <div className="blog-hero-content">
          <div className="blog-hero-content-inner">
            <h1 className="hero-title blog-hero-title">
              Cybersecurity Insights &amp; Intelligence
            </h1>
            <p className="blog-hero-subtitle hero-subtitle">
              Expert analysis on security threats, compliance frameworks,
              AI-driven protection, and emerging attack vectors shaping
              enterprise defense strategies
            </p>
            <div className="hero-cta-group">
              <a href="#latest">
                <div className="btn-primary btn btn-lg">
                  <span>Explore Latest Articles</span>
                </div>
              </a>
              <a href="#subscribe">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Subscribe to Updates</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="stats-section">

      
        <div className="stats-wrapper">
          <div className="stats-scroller">
            <div className="stats-item">
              <div className="stats-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="stats-content">
                <h3 className="stats-title">ISO 27001 Certified</h3>
                <p className="stats-description">
                  Information Security Management
                </p>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-content">
                <h3 className="stats-title">SOC 2 Type II</h3>
                <p className="stats-description">Trust Service Principles</p>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <div className="stats-content">
                <h3 className="stats-title">PCI-DSS Compliant</h3>
                <p className="stats-description">
                  Payment Card Industry Standards
                </p>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <div className="stats-content">
                <h3 className="stats-title">Industry Awards</h3>
                <p className="stats-description">
                  Recognized Excellence in Security
                </p>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <div className="stats-content">
                <h3 className="stats-title">Certified Experts</h3>
                <p className="stats-description">
                  CISSP, CEH, OSCP Professionals
                </p>
              </div>
            </div>
            <div className="stats-item">
              <div className="stats-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="stats-content">
                <h3 className="stats-title">Global Reach</h3>
                <p className="stats-description">
                  Enterprise Protection Worldwide
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      
      
      
      <div className="blog-container2">
        <div className="blog-container3">
          <Script
            html={`<script defer data-name="testimonials-scroll">
(function(){
  const testimonialsRail = document.querySelector(".testimonials-rail")
  if (testimonialsRail) {
    let isDown = false
    let startX
    let scrollLeft

    testimonialsRail.addEventListener("mousedown", (e) => {
      isDown = true
      testimonialsRail.style.cursor = "grabbing"
      startX = e.pageX - testimonialsRail.offsetLeft
      scrollLeft = testimonialsRail.scrollLeft
    })

    testimonialsRail.addEventListener("mouseleave", () => {
      isDown = false
      testimonialsRail.style.cursor = "grab"
    })

    testimonialsRail.addEventListener("mouseup", () => {
      isDown = false
      testimonialsRail.style.cursor = "grab"
    })

    testimonialsRail.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - testimonialsRail.offsetLeft
      const walk = (x - startX) * 2
      testimonialsRail.scrollLeft = scrollLeft - walk
    })

    testimonialsRail.style.cursor = "grab"
  }

  const statsScroller = document.querySelector(".stats-scroller")
  if (statsScroller) {
    let isDown = false
    let startX
    let scrollLeft

    statsScroller.addEventListener("mousedown", (e) => {
      isDown = true
      statsScroller.style.cursor = "grabbing"
      startX = e.pageX - statsScroller.offsetLeft
      scrollLeft = statsScroller.scrollLeft
    })

    statsScroller.addEventListener("mouseleave", () => {
      isDown = false
      statsScroller.style.cursor = "grab"
    })

    statsScroller.addEventListener("mouseup", () => {
      isDown = false
      statsScroller.style.cursor = "grab"
    })

    statsScroller.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - statsScroller.offsetLeft
      const walk = (x - startX) * 2
      statsScroller.scrollLeft = scrollLeft - walk
    })

    statsScroller.style.cursor = "grab"
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      {/* Blogs Section Start */}
      <section className="blogs-section">
        <div className="blogs-header">
          <h2 className="section-title">Latest Blogs</h2>
          <p className="section-subtitle">Insights, trends, and expert advice from our cybersecurity team</p>
        </div>
        <div className="blogs-grid">
          {/* Blog Card 1 */}
          <div className="blog-card animated-card">
            <div className="blog-card-image">
              <img src="https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&w=800" alt="Zero Trust Security" />
            </div>
            <div className="blog-card-content">
              <h3 className="blog-card-title">Zero Trust: The New Security Paradigm</h3>
              <p className="blog-card-desc">Explore how Zero Trust is reshaping enterprise security, reducing attack surfaces, and enabling secure remote workforces in a cloud-first world.</p>
            </div>
            <div className="blog-card-footer">
              <span className="blog-card-viewers">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                2,345 viewers
              </span>
              <a className="blog-card-readmore" href="#zero-trust">Read More &rarr;</a>
            </div>
          </div>
          {/* Blog Card 2 */}
          <div className="blog-card animated-card">
            <div className="blog-card-image">
              <img src="https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&w=800" alt="AI in Cybersecurity" />
            </div>
            <div className="blog-card-content">
              <h3 className="blog-card-title">AI &amp; Machine Learning in Threat Detection</h3>
              <p className="blog-card-desc">Discover how AI-driven analytics are transforming threat detection, automating response, and staying ahead of sophisticated cyber attacks.</p>
            </div>
            <div className="blog-card-footer">
              <span className="blog-card-viewers">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                1,890 viewers
              </span>
              <a className="blog-card-readmore" href="#ai-cyber">Read More &rarr;</a>
            </div>
          </div>
          {/* Blog Card 3 */}
          <div className="blog-card animated-card">
            <div className="blog-card-image">
              <img src="https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&w=800" alt="Cloud Security" />
            </div>
            <div className="blog-card-content">
              <h3 className="blog-card-title">Cloud Security: Best Practices for 2025</h3>
              <p className="blog-card-desc">A practical guide to securing your cloud infrastructure, managing identities, and ensuring compliance in multi-cloud environments.</p>
            </div>
            <div className="blog-card-footer">
              <span className="blog-card-viewers">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                3,102 viewers
              </span>
              <a className="blog-card-readmore" href="#cloud-security">Read More &rarr;</a>
            </div>
          </div>
        </div>
      </section>
      {/* Blogs Section End */}
      <Footer></Footer>
    </div>
  );
};

export default Blog;
